import { ApplicationRef, ChangeDetectorRef, Injectable, Injector } from "@angular/core";

/**
 * angular èå¼æ£æ¥æå¡
 */
@Injectable()
export class DirtyCheckingService {
  constructor(public injector: Injector, private cd: ChangeDetectorRef, private appRef: ApplicationRef) {
  }
  /**
   * Checks this view and its children. 
   * @param global æ¯å¦å¨å±æ£æ¥
   */
  public detectChanges(global?: boolean | string) {
    global = (global === true || global === 'true') ? true : false;
    if (global && this.appRef) {
      this.appRef.tick();
    } else if (this.cd) {
      this.cd.detectChanges();
    }
  }
  /**
   * å¨æå®æ¶é´ï¼msï¼åè§¦åAngularèå¼æ£æ¥
   * @param duration è¶æ¶æ¶é´(ms)
   * @param global æ¯å¦å¨å±æ£æ¥
   */
  public detectChangesAfter(duration: number, global?: boolean | string) {
    global = (global === true || global === 'true') ? true : false;
    if (isNaN(duration)) {
      return;
    }
    if (global && this.appRef) {
      window.setTimeout(() => {
        this.appRef.tick();
      }, duration);
    } else if (this.cd) {
      window.setTimeout(() => {
        this.cd.detectChanges();
      }, duration);
    }
  }
}